import React, { useState, useEffect } from "react";

// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Form,
    Container,
    Row,
    Col,
    Spinner
} from "reactstrap";
// core components
import Header from "../../../../components/Headers/BasicHeader";
import { useNavigate, useParams } from "react-router-dom";
import { getPayment, postPayment, putPayment } from "network/ApiAxios";
import AccountInformation from "./AccountInformation";
import PaymentInformation from "./PaymentInformation";
import ManagementInformation from './ManagementInformation';
import BasicModal from '../../../../components/Modals/BasicModal'
import { validateData } from '../../../../utils/views/pages/Dynamics'

const Profile = (props) => {

    const navigate = useNavigate();
    const params = useParams()
    const [payment, setPayment] = useState({});
    const formDisabled = (props.action == "view")
    const validations = {}
    const [isLoading, setisLoading] = useState(false)

    useEffect(() => {

        const runAsync = async () => {
            const response = await getPayment(params.id);
            const { data } = response;
            
            if (data.success) {
                setPayment(data.payment);
            } 
        }

        runAsync();

    }, []);



    return (
        <>
            <Header />

            <Container className="border-0 pb-0 pt-0 pt-md-3" fluid>
                <Row>

                    <Col className="order-xl-1" >
                        <Card className=" shadow">
                            <CardHeader className="bg-white border-0">
                                <Row className="align-items-center">
                                    <Col xs="8" className="text-left">
                                        <Button onClick={() => navigate('/admin/payments')}
                                            className="btn-back" type="button">

                                            <span className="btn-inner--icon">
                                                <i className="ni ni-bold-left" />
                                            </span>

                                            <span className="btn-inner--text h3 mb-0">Payment's Profile</span>

                                        </Button>
                                        
                                    </Col>

                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Form>

                                    <PaymentInformation
                                        payment={payment}
                                        formDisabled={formDisabled}
                                        setPayment={setPayment}
                                        validations={validations} />

                                    <hr className="my-4" />

                                    <ManagementInformation
                                        payment={payment}
                                        formDisabled={formDisabled}
                                        setPayment={setPayment}
                                        validations={validations} />

                                    <AccountInformation
                                        payment={payment}
                                        formDisabled={true} />

                                    <hr className="my-4" />

                                    <Row className="align-items-left">
                                        <Col className="text-left" xs="4">

                                            <Button onClick={() => navigate('/admin/payments')}
                                                className="btn-icon btn-3" color="primary" type="button">

                                                <span className="btn-inner--icon">
                                                    <i className="ni ni-bold-left" />
                                                </span>

                                                <span className="btn-inner--text">Back</span>

                                            </Button>

                                        </Col>



                                    </Row>

                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

        </>
    );
}

export default Profile;
